import React from "react";
import { GreenEllipse, RedEllipse, RightArrowIcon } from "../../../Icons";

const Card = ({ card }) => {
  return (
    <div
      key={card.id}
      className="othercard-card-wrapper"
    >
      <div className="flex">
        {card.status === "Active" ? (
          <img
            src={
              card.card_brand.toLowerCase() === "visa"
                ? "assets/logos/visa-othercard-bg.png"
                : "assets/logos/match-move-othercard-bg.png"
            }
            alt="Other Cards"
            className="othercard-image"
          />
        ) : (
          <img
            src={`${
              card.card_provider.toLowerCase() === "mm"
                ? "assets/logos/match-move-othercard-bg.png"
                : "assets/logos/visa-othercard-bg.png"
            }`}
            alt="Other Cards"
            className={`othercard-image ${card.status !== "Active" ? "bg-zinc-400 opacity-60" : ""}`}
          />
        )}
        <div className="ml-3">
          <p className="othercard-title">{card.name}</p>
          <span className="flex items-center space-x-2">
            {card.status === "Active" ? <GreenEllipse /> : <RedEllipse />}
            <p className="othercard-status">
              {card.status} | · · {card.card_number.slice(-4)}
            </p>
          </span>
        </div>
      </div>

      <div className="flex items-center justify-center text-text-primary text-sm font-medium leading-tight tracking-tight">
        <RightArrowIcon />
      </div>
    </div>
  );
};

export default Card;
